import { Form, Select } from 'antd';
import type { ReactNode } from 'react';

import type { SOURCE_TYPE } from '@/types/feedbackConst';

export const SourceTypeField = (props: {
  sourceOptions: { label: ReactNode; value: SOURCE_TYPE }[];
  disabled?: boolean;
  layout?: 'horizontal' | 'vertical';
}) => {
  const { sourceOptions, disabled, layout = 'horizontal' } = props;

  return (
    <Form.Item
      label="Platform"
      required
      name="source_type"
      layout={layout}
      rules={[{ required: true, message: 'Platform is required' }]}
    >
      <Select
        options={sourceOptions}
        placeholder="Select platform"
        disabled={disabled}
      />
    </Form.Item>
  );
};
